export default __webpack_public_path__ + "static/media/th.d0cb3548.svg";